import BaseModel from "../BaseModel";
import AddressType from "./AddressType";
import RegionType from "./RegionType";
export default class Address extends BaseModel{
    static entity = 'addresses';
    static fields(){
        return {
            id: this.attr(null),
            customer_id: this.attr(null),
            street: this.attr(null),
            city: this.attr(null),
            state: this.attr(null),
            zipcode: this.attr(null),
            zipcodepf: this.attr(null),
            county: this.attr(null),
            region_type_id: this.number(null).nullable(),
            lat: this.attr(null),
            lon: this.attr(null),
            address_type_id: this.attr(null),
            user_id: this.attr(null),
            address_type: this.belongsTo(AddressType, 'address_type_id'),
            region_type: this.belongsTo(RegionType, 'region_type_id')
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'address_type', 'region_type']
    }
    static route(){
        return '/addresses'
    }
}
